export const TAX_RECEIPT_NUMBERING_MODES = [
    "AnnualCounter",
    "GlobalCounter",
];
/** Zero-padded width of the counter part accepted by OPDON (`TaxReceiptSettingsValues`). */
export const TAX_RECEIPT_COUNTER_SIZES = [3, 4, 5, 6];
export const TAX_RECEIPT_PREFIX_MAX_LENGTH = 10;
/** 1 to 10 uppercase letters or digits — the OPDON prefix rule. */
export const TAX_RECEIPT_PREFIX_PATTERN = /^[A-Z0-9]{1,10}$/;
/** Upper bound of EACH recipient list (users, roles) on the OPDON validator. */
export const TAX_RECEIPT_MAX_NOTIFICATION_RECIPIENTS = 100;
export function createDefaultTaxReceiptSettings() {
    return {
        mode: "PerDonation",
        moduleEnabled: false,
        campaignTriggerDay: 5,
        campaignTriggerMonth: 1,
        campaignNotificationUserIds: [],
        campaignNotificationRoles: [],
        campaignFirstFiscalYear: null,
        numberingMode: "AnnualCounter",
        numberingPrefix: "RF",
        numberingCounterSize: 6,
        numberingLocked: false,
        documentTemplateIndividualId: null,
        documentTemplateOrganizationId: null,
        updatedAt: null,
    };
}
/** Days in a month of a leap year — the same reference year OPDON validates against (29 February allowed). */
export function daysInMonth(month) {
    return new Date(2000, month, 0).getDate();
}
export function isValidTriggerDate(day, month) {
    return (Number.isInteger(month) &&
        month >= 1 &&
        month <= 12 &&
        Number.isInteger(day) &&
        day >= 1 &&
        day <= daysInMonth(month));
}
/** The years a first fiscal year can be newly set to: the last closed one, then the current one. */
export function campaignFirstFiscalYearChoices(currentYear) {
    return [currentYear, currentYear - 1];
}
/**
 * The OPDON rule: `null` (no automatic campaign), the year already saved, or a newly chosen last
 * closed or current year — an older one would generate and email every year since at once.
 */
export function isValidCampaignFirstFiscalYear(year, currentYear, savedYear) {
    return year === null || year === savedYear || campaignFirstFiscalYearChoices(currentYear).includes(year);
}
export function isValidNumberingPrefix(prefix) {
    return TAX_RECEIPT_PREFIX_PATTERN.test(prefix);
}
/**
 * First number the configured format would produce: `RF-2026-000001` in annual mode,
 * `RF-000001` in global mode (OPDON `TaxReceiptNumberFormat`).
 */
export function formatTaxReceiptNumberPreview(mode, prefix, counterSize, year) {
    const counter = "1".padStart(counterSize, "0");
    return mode === "AnnualCounter" ? `${prefix}-${year}-${counter}` : `${prefix}-${counter}`;
}
